import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminMenu() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Cabecera fija */}
      <div style={styles.cabecera}>
        <button 
          style={styles.botonMenu}
          onClick={() => setMenuAbierto(!menuAbierto)}
        >
          ☰
        </button>
        <h1 style={styles.titulo}>MundiEmby</h1>
      </div>

      {/* Menú lateral */}
      {menuAbierto && (
        <div style={styles.menu}>
          <div style={styles.menuWrapper}>
          <div style={styles.opciones}>
  <button style={styles.opcion} onClick={() => navigate('/admin/sesiones')}>
    📺 Reproducciones
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/usuarios')}>
    👥 Gestión Usuarios
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/peticiones')}>
    📩 Peticiones
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/ampliaciones')}>
    ➕ Ampliaciones
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/noticias')}>
    📰 Estrenos
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/monitor')}>
    🖥️ Monitor del Servidor
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/descargas')}>
                📥 Descargas
  </button>
  <button style={styles.opcion} onClick={() => navigate('/admin/backup')}>
  🗄️ Backup y Restauración
</button>
</div>


            <div style={styles.footer}>
              <button style={styles.cerrar} onClick={() => navigate('/')}>
                ⛔ Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  cabecera: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1001,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: '#1e1e1e',
    padding: '10px 20px',
    height: '60px',
    width: '100%'
  },
  botonMenu: {
    backgroundColor: '#2b2b2b',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: '4px',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titulo: {
    fontSize: '24px',
    color: 'limegreen',
    margin: 0
  },
  menu: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: '#2b2b2b',
    height: '100vh',
    width: '250px',
    boxShadow: '2px 0 10px rgba(0,0,0,0.5)',
    display: 'flex',
    flexDirection: 'column'
  },
  menuWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '90px',
    paddingBottom: '20px',
    overflowY: 'auto',
    justifyContent: 'space-between'
  },
  opciones: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '0 20px'
  },
  opcion: {
    padding: '10px',
    backgroundColor: '#0078D7',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    textAlign: 'left'
  },
  footer: {
    padding: '0 20px'
  },
  cerrar: {
    padding: '10px',
    backgroundColor: 'crimson',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%'
  }
};

export default AdminMenu;
